// 定义加解密方式和秘钥
import CryptoJS from 'crypto-js';
 
export default {
    //随机生成指定数量的16进制key
    generatekey(num) {
        let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let key = "";
        for (var i = 0; i < num; i++) {
            let randomPoz = Math.floor(Math.random() * library.length);
            key += library.substring(randomPoz, randomPoz + 1);
        }
        return key;
    },
    
    //加密
    encrypt(word, keyStr) {
        if(keyStr == "1"){
            keyStr = "mYTW1weFUhcVuZXf";
        }else if(keyStr == "3"){
            keyStr = "pKTUhgMcvR6bGLoj"; //QA  1zTiW90YtYH00SCU  Prod pKTUhgMcvR6bGLoj
        }else if(keyStr == "4"){
            keyStr = "MVQ3Rbja5rACW34840JsaqhfNPhqOTx3"
        }else if(keyStr == "5"){
            keyStr = "FvM6thrJqcZPPHvN" //QA gE8BvhSFhfisncOE prod FvM6thrJqcZPPHvN
        }else{
            keyStr = "mYTW1weFUhcVuZXf";
        }           
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    },
    //解密
    decrypt(word, keyStr) {
        if(keyStr == "1"){
            keyStr = "mYTW1weFUhcVuZXf";
        }else if(keyStr == "3"){
            keyStr = "1zTiW90YtYH00SCU"; //QA 1zTiW90YtYH00SCU prod:pKTUhgMcvR6bGLoj
        }else if(keyStr == "4"){
            keyStr = "MVQ3Rbja5rACW34840JsaqhfNPhqOTx3"
        }else if(keyStr == "5"){
            keyStr = "gE8BvhSFhfisncOE" //QA gE8BvhSFhfisncOE prod FvM6thrJqcZPPHvN
        }else{
            keyStr = "mYTW1weFUhcVuZXf";
        }
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },

    encryptDES(message) {
        var keyHex = CryptoJS.enc.Utf8.parse("FBB6CB8915E0EC61F4802C83739B23D3134AD00198321A68"); //QA 19C44CC1D037EFD0455EFD9E4C64B3E3AE0EF4A45813A194
        if (message) {
          var encrypt = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          return encrypt.toString();
        } else {
          return '';
        }
      },
      
      // 解密
      decryptDES(ciphertext){
        var keyHex = CryptoJS.enc.Utf8.parse("FBB6CB8915E0EC61F4802C83739B23D3134AD00198321A68"); //QA  19C44CC1D037EFD0455EFD9E4C64B3E3AE0EF4A45813A194
        if (ciphertext) {
          let decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          return decrypted.toString(CryptoJS.enc.Utf8);
        } else {
          return '';
        }
      }
}



// WEBPACK FOOTER //
// ./src/common/AES.js